import Absensi from "../../../../../components/categories/siakad/lms/data_absensi/Home";
export default function Home() {
  
  return (
    <Absensi />
  );
}
